'use strict';

var _defineProperty = require("/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/tellow.nl/tellow.nl/apps/leadsite/node_modules/@babel/runtime/helpers/createClass.js");
var XmlNode = /*#__PURE__*/function () {
  function XmlNode(tagname) {
    _classCallCheck(this, XmlNode);
    this.tagname = tagname;
    this.child = []; //nested tags, text, cdata, comments in order
    this[":@"] = {}; //attributes map
  }
  _createClass(XmlNode, [{
    key: "add",
    value: function add(key, val) {
      // this.child.push( {name : key, val: val, isCdata: isCdata });
      if (key === "__proto__") key = "#__proto__";
      this.child.push(_defineProperty({}, key, val));
    }
  }, {
    key: "addChild",
    value: function addChild(node) {
      if (node.tagname === "__proto__") node.tagname = "#__proto__";
      if (node[":@"] && Object.keys(node[":@"]).length > 0) {
        var _this$child$push2;
        this.child.push((_this$child$push2 = {}, _defineProperty(_this$child$push2, node.tagname, node.child), _defineProperty(_this$child$push2, ":@", node[":@"]), _this$child$push2));
      } else {
        this.child.push(_defineProperty({}, node.tagname, node.child));
      }
    }
  }]);
  return XmlNode;
}();
;
module.exports = XmlNode;